import { processLocalizedURLAddress } from '@vue-storefront/core/helpers'
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import RootState from '@vue-storefront/core/types/RootState'
import config from 'config'
import { Module } from 'vuex'
import getApiEndpointUrl from '@vue-storefront/core/helpers/getApiEndpointUrl'

export const module: Module<any, RootState> = {
  namespaced: true,
  actions: {
    async generateGiftCertificate ({ commit }, { incrementId, recipient, message, signature, imageId }) {
      const response = await TaskQueue.execute({
        url: processLocalizedURLAddress(
          getApiEndpointUrl(config.giftCertificate, 'generate')
        ),
        payload: {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          body: JSON.stringify({
            incrementId,
            recipient,
            message,
            signature,
            imageId
          })
        }
      })

      if (response.code !== 200) {
        throw new Error(response.result?.errorMessage || 'Failed to generate gift certificate')
      }

      return response
    }
  }
}
